import { Spin } from 'antd';
import styled from 'styled-components';

export default styled(Spin)`
	// Add your styles here
`;
